
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Lottie from 'lottie-react';

import { RecipeMealPlanLoad, RecipeMealPlanSuccess } from '../../utils/lottieRefs';
import styles from './recipeMealPlanLoader.module.css';

const Loader = () => (
    <Grid className={styles.loader_and_text}>
        <Grid className={styles.animation_container}>
            <Lottie animationData={RecipeMealPlanLoad} loop />
        </Grid>
        <Typography className={styles.loading_text} variant='ingredientText1Outfit'>
            Scheduling...
        </Typography>

    </Grid>
);

const Success = () => (
    <Grid className={styles.loader_and_text}>
        <Grid className={styles.animation_container}>
            <Lottie animationData={RecipeMealPlanSuccess} loop={false} />
        </Grid>
        <Typography className={styles.loading_text} variant="ingredientText1Outfit">
            Scheduled Successfully.
        </Typography>
    </Grid>

);

const RecipeMealPlanLoader = ({
    loading,
    hasCompletedLoop,
}: {
    loading: boolean;
    hasCompletedLoop: boolean;
}) => {
    const isLoading = loading || !hasCompletedLoop;

    return (
        <Modal open>
            <Grid className={styles.loader_container}>
                {isLoading ? <Loader /> : <Success />}
            </Grid>
        </Modal>
    );
};

export default RecipeMealPlanLoader;
